import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import { gameSectionStore } from "../stores/gamesSection";
import { gameStore } from "../stores/games";
import { blackListWithdrawalsStore } from "../stores/blackListWithdrawals";
import { blackListWithdrawalsAddModalStore } from "../stores/whiteListPlayersWithdrawalsAddModal";
import { whiteListPlayersWithdrawalsAddModalStore } from "../stores/whiteListPlayersWithdrawalsAddModal";
import { whiteListPlayersWithdrawalStore } from "../stores/whiteListPlayersWithdrawals";
import Select from "@cloudscape-design/components/select";
/* ------- */

class WhiteListPlayerWithdrawalsAddModal extends React.Component {
	componentDidUpdate(prevProps) {
		if (!prevProps.whiteListPlayersWithdrawalsAddModal.show && this.props.whiteListPlayersWithdrawalsAddModal.show) {
			this.resetFormFields();
		}
	}

	resetFormFields = () => {
		this.props.setWhiteListPlayersWithdrawalsAddModal({
			...this.props.whiteListPlayersWithdrawalsAddModal,
			wallet: '',
			loaded: true
		});
	};


	addWhiteListWithdrawal() {
		const data = {
			uid: this.props.whiteListPlayersWithdrawalsAddModal.uid,
			description: this.props.whiteListPlayersWithdrawalsAddModal.description,
			brand: this.props.whiteListPlayersWithdrawalsAddModal.brand.value
		}
		this.props.Interface.request("set", {
			class: "data",
			module: "whistListPlayersWithdrawal",
			method: "add"
		}, { ...data }).then((result) => {
			this.props.Interface.addNoty("Success", "Create white list was success");
			this.props.setWhiteListPlayersWithdrawalsAddModal({ ...this.props.whiteListPlayersWithdrawalsAddModal, show: false});
			this.props.Interface.loadWhiteListPlayersWithdrawals();
		}).catch((error) => {
			if (typeof error.text === "undefined") error = { text: error.toString() };
			this.props.setWhiteListPlayersWithdrawals({ ...this.props.whiteListPlayersWithdrawals, loaded: true, error });
		})
	}


	render() {
		return (
			<>
				<Modal
					visible={this.props.whiteListPlayersWithdrawalsAddModal.show}
					onDismiss={() => {
						this.props.setWhiteListPlayersWithdrawalsAddModal({ ...this.props.whiteListPlayersWithdrawalsAddModal, show: false });
					}}
					header="Add white list"
					children={
						<>
							<SpaceBetween direction="vertical" size="m">
								<Input
									autoFocus="true"
									name="Name"
									autoComplete="off"
									inputMode="text"
									type="text"
									disableBrowserAutocorrect={true}
									placeholder="UID"
									value={this.props.whiteListPlayersWithdrawalsAddModal.uid}
									onChange={(input) => {
										this.props.setWhiteListPlayersWithdrawalsAddModal({ ...this.props.whiteListPlayersWithdrawalsAddModal, uid: input.detail.value });
									}}
								/>
								<Select
									filteringType="auto"
									placeholder="Select brand"
									selectedOption={this.props.whiteListPlayersWithdrawalsAddModal.brand}
									onChange={(option) => {
										this.props.setWhiteListPlayersWithdrawalsAddModal({ ...this.props.whiteListPlayersWithdrawalsAddModal, brand: option.detail.selectedOption });
									}
									}
									options={this.props.whiteListPlayersWithdrawalsAddModal.currentOption.brand}
								/>
								<Input
									autoFocus="true"
									name="Description"
									autoComplete="off"
									inputMode="text"
									type="text"
									disableBrowserAutocorrect={true}
									placeholder="Description"
									value={this.props.whiteListPlayersWithdrawalsAddModal.description}
									onChange={(input) => {
										this.props.setWhiteListPlayersWithdrawalsAddModal({ ...this.props.whiteListPlayersWithdrawalsAddModal, description: input.detail.value });
									}}
								/>
							</SpaceBetween>
						</>
					}
					footer={
						<>
							<Box
								float="right"
								children={
									<>
										<Box
											variant="span"
											margin={{ right: "s" }}
											children={
												<Button
													variant="normal"
													onClick={() => {
														this.props.setWhiteListPlayersWithdrawalsAddModal({ ...this.props.whiteListPlayersWithdrawalsAddModal, show: false });
													}}
													children="Close"
												/>
											}
										/>
										<Box
											variant="span"
											children={
												<Button
													disabled={this.props.whiteListPlayersWithdrawalsAddModal.wallet === ""}
													variant="primary"
													onClick={() => {
														this.addWhiteListWithdrawal();
													}}
													children="Ok"
												/>
											}
										/>
									</>
								}
							/>
						</>
					}
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const whiteListPlayersWithdrawalsAddModal = useRecoilValue(whiteListPlayersWithdrawalsAddModalStore);
		const setWhiteListPlayersWithdrawalsAddModal = useSetRecoilState(whiteListPlayersWithdrawalsAddModalStore);
		const whiteListPlayersWithdrawals = useRecoilValue(whiteListPlayersWithdrawalStore);
		const setWhiteListPlayersWithdrawals = useSetRecoilState(whiteListPlayersWithdrawalStore);
		const config = useRecoilValue(configStore);
		return <Component {...props}  whiteListPlayersWithdrawalsAddModal={whiteListPlayersWithdrawalsAddModal} setWhiteListPlayersWithdrawalsAddModal={setWhiteListPlayersWithdrawalsAddModal} whiteListPlayersWithdrawals={whiteListPlayersWithdrawals} setWhiteListPlayersWithdrawals={setWhiteListPlayersWithdrawals} config={config} />;
	};
}

export default withRecoil(WhiteListPlayerWithdrawalsAddModal);
